import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.75 3.375C3.75 2.33979 4.58979 1.5 5.625 1.5H10.5C13.0859 1.5 15.5658 2.52723 17.3943 4.35571C19.2228 6.18419 20.25 8.66414 20.25 11.25V20.625C20.25 21.6602 19.4102 22.5 18.375 22.5H5.625C4.58979 22.5 3.75 21.6602 3.75 20.625V3.375ZM18.0797 7.99251C17.6702 7.03985 17.081 6.16379 16.3336 5.41637C15.5862 4.66895 14.7101 4.07976 13.7575 3.67034C14.0779 4.2658 14.25 4.93653 14.25 5.625V7.125C14.25 7.33179 14.4182 7.5 14.625 7.5H16.125C16.8135 7.5 17.4842 7.67212 18.0797 7.99251ZM10.125 3H5.625C5.41821 3 5.25 3.16821 5.25 3.375V20.625C5.25 20.8318 5.41821 21 5.625 21H18.375C18.5818 21 18.75 20.8318 18.75 20.625V11.625C18.75 10.9288 18.4734 10.2611 17.9812 9.76884C17.4889 9.27656 16.8212 9 16.125 9H14.625C13.5898 9 12.75 8.16021 12.75 7.125V5.625C12.75 4.92881 12.4734 4.26113 11.9812 3.76884C11.4889 3.27656 10.8212 3 10.125 3ZM15.4359 11.3897C15.773 11.6305 15.8511 12.0989 15.6103 12.4359L11.8603 17.6859C11.7322 17.8653 11.5316 17.9793 11.3119 17.9974C11.0921 18.0156 10.8756 17.9362 10.7197 17.7803L8.46967 15.5303C8.17678 15.2374 8.17678 14.7626 8.46967 14.4697C8.76256 14.1768 9.23744 14.1768 9.53033 14.4697L11.1543 16.0936L14.3897 11.5641C14.6305 11.227 15.0989 11.1489 15.4359 11.3897Z"
        fill={colorValue}
      />
    </svg>
  );
};
